import { DealType, DealVersion } from '../../../types/deal.types';
import { Moment } from 'moment';
import { IssueDate } from '../../../helpers/issue/date';
import { isDefined } from '../../../utils/utils';
import { DesignationIssue } from '../../../types/designation.types';

export function dealDateValueGetter(
  deal: DealVersion | undefined
): IssueDate.DealWithFormattedDate {
  // Handle null or undefined values
  if (!isDefined(deal)) {
    return undefined;
  }

  const dealDate: Moment = IssueDate.getDealDate(deal);
  const {
    date: dealDateFormatted,
    time: dealTimeFormatted,
    timeNoTimezone: dealTimeNoTimezone
  } = IssueDate.getFormattedDealDateByPriority(deal);
  const filterOption: string | Moment =
    (deal.dealType === DealType.negotiated && deal.isWeekOf) ||
    [IssueDate.Priority.DayToDay, IssueDate.Priority.TBD].includes(
      dealDateFormatted as IssueDate.Priority
    )
      ? dealDateFormatted
      : dealDate && dealDate.format(IssueDate.Formats.dddMDD);

  return {
    ...deal,
    dealDate,
    dealDateFormatted,
    dealTimeFormatted,
    dealTimeNoTimezone,
    filterOption
  };
}

export function desiDealDateValueGetter(
  deal: DealVersion | DesignationIssue | undefined
): IssueDate.DesiDealWithFormattedDate {
  // Handle null or undefined values
  if (!isDefined(deal)) {
    return undefined;
  }

  const dealDate: Moment = IssueDate.getDealDate(deal as DealVersion);
  const {
    date: dealDateFormatted,
    time: dealTimeFormatted,
    timeNoTimezone: dealTimeNoTimezone
  } = IssueDate.getFormattedDealDateByPriority(deal as DealVersion);

  return {
    ...(deal as DesignationIssue),
    dealDate,
    dealDateFormatted,
    dealTimeFormatted,
    dealTimeNoTimezone
  };
}
